require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-30-project-associated-with-a-trial.json") })
        }
      }, "path---article-30-project-associated-with-a-trial");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-30-project-associated-with-a-trial!./.cache/json/article-30-project-associated-with-a-trial.json
// module id = 544
// module chunks = 231608221292675